import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["vatInput", "countryFlag", "countryCode", "countryPrefix", "validationStatus", "validIcon", "invalidIcon", "checkingIcon"]
  static values = { currentCountry: String }

  // VAT validation patterns for European countries
  static countryData = {
    'LT': { code: 'LT VAT', pattern: /^(LT)?\d{9}$/ },
    'LV': { code: 'LV VAT', pattern: /^(LV)?\d{11}$/ },
    'EE': { code: 'EE VAT', pattern: /^(EE)?\d{9}$/ },
    'DE': { code: 'DE VAT', pattern: /^(DE)?\d{9}$/ },
    'GB': { code: 'GB VAT', pattern: /^(GB)?(\d{9}|\d{12})$/ },
    'FR': { code: 'FR VAT', pattern: /^(FR)?[A-Z0-9]{2}\d{9}$/ },
    'PL': { code: 'PL VAT', pattern: /^(PL)?\d{10}$/ },
    'NL': { code: 'NL VAT', pattern: /^(NL)?\d{9}B\d{2}$/ },
    'BE': { code: 'BE VAT', pattern: /^(BE)?[01]\d{9}$/ },
    'IE': { code: 'IE VAT', pattern: /^(IE)?(\d{7}[A-Z]|\d[A-Z]\d{5}[A-Z]|\d{7}[A-Z]{2})$/ },
    'AT': { code: 'AT VAT', pattern: /^(AT)?U\d{8}$/ },
    'BG': { code: 'BG VAT', pattern: /^(BG)?\d{9,10}$/ },
    'HR': { code: 'HR VAT', pattern: /^(HR)?\d{11}$/ },
    'CY': { code: 'CY VAT', pattern: /^(CY)?\d{8}[A-Z]$/ },
    'CZ': { code: 'CZ VAT', pattern: /^(CZ)?\d{8,10}$/ },
    'DK': { code: 'DK VAT', pattern: /^(DK)?\d{8}$/ },
    'FI': { code: 'FI VAT', pattern: /^(FI)?\d{8}$/ },
    'GR': { code: 'GR VAT', pattern: /^(EL|GR)?\d{9}$/ },
    'HU': { code: 'HU VAT', pattern: /^(HU)?\d{8}$/ },
    'IS': { code: 'IS VAT', pattern: /^(IS)?\d{5,6}$/ },
    'IT': { code: 'IT VAT', pattern: /^(IT)?\d{11}$/ },
    'LU': { code: 'LU VAT', pattern: /^(LU)?\d{8}$/ },
    'MT': { code: 'MT VAT', pattern: /^(MT)?\d{8}$/ },
    'NO': { code: 'NO VAT', pattern: /^(NO)?\d{9}(MVA)?$/ },
    'PT': { code: 'PT VAT', pattern: /^(PT)?\d{9}$/ },
    'RO': { code: 'RO VAT', pattern: /^(RO)?\d{2,10}$/ },
    'SK': { code: 'SK VAT', pattern: /^(SK)?\d{10}$/ },
    'SI': { code: 'SI VAT', pattern: /^(SI)?\d{8}$/ },
    'ES': { code: 'ES VAT', pattern: /^(ES)?[A-Z0-9]\d{7}[A-Z0-9]$/ },
    'SE': { code: 'SE VAT', pattern: /^(SE)?\d{12}$/ },
    'CH': { code: 'CH VAT', pattern: /^(CHE-)?\d{9}(TVA|MWST|IVA)?$/ }
  }

  connect() {
    this.updateCountryDisplay()
    this.validateFormat()
    
    // Listen for country changes from the form dropdown
    this.element.addEventListener('countryChanged', (event) => {
      this.currentCountryValue = event.detail.country
    })
  }

  currentCountryValueChanged() {
    this.updateCountryDisplay()
    this.validateFormat()
  }

  updateCountryDisplay() {
    const country = this.currentCountryValue || 'LT'
    const data = this.constructor.countryData[country] || this.constructor.countryData['LT']
    
    // Update flag using flag-icons classes
    if (this.hasCountryFlagTarget) {
      // Remove all flag classes and add new ones
      this.countryFlagTarget.className = `fi fi-${country.toLowerCase()} w-5 h-3`
    }
    if (this.hasCountryCodeTarget) {
      this.countryCodeTarget.textContent = data.code
    }
  }

  validateFormat() {
    if (!this.hasVatInputTarget) return

    const value = this.vatInputTarget.value.trim().toUpperCase()
    const country = this.currentCountryValue || 'LT'
    
    if (!value) {
      this.hideValidation()
      return
    }

    const data = this.constructor.countryData[country]
    if (!data || !data.pattern) {
      this.hideValidation()
      return
    }

    if (data.pattern.test(value)) {
      this.showValidation('valid')
      // Could add actual VAT validation via VIES API here
    } else {
      this.showValidation('invalid')
    }
  }

  showValidation(status) {
    if (!this.hasValidationStatusTarget) return

    this.validationStatusTarget.classList.remove('hidden')
    
    if (status === 'valid') {
      this.validIconTarget.classList.remove('hidden')
      this.invalidIconTarget.classList.add('hidden')
      this.checkingIconTarget.classList.add('hidden')
    } else if (status === 'invalid') {
      this.validIconTarget.classList.add('hidden')
      this.invalidIconTarget.classList.remove('hidden')
      this.checkingIconTarget.classList.add('hidden')
    } else if (status === 'checking') {
      this.validIconTarget.classList.add('hidden')
      this.invalidIconTarget.classList.add('hidden')
      this.checkingIconTarget.classList.remove('hidden')
    }
  }

  hideValidation() {
    if (this.hasValidationStatusTarget) {
      this.validationStatusTarget.classList.add('hidden')
    }
  }
}